<template>
  <div class="profile">
    <div class="row">
      <div class="col-6 col-xs-12">
        <h2 class="page-title">{{$t('account.edit_account')}}</h2>
        <form @submit.prevent="editProfile('form-1')" class="columns column is-multiline is-12" data-vv-scope="form-1">
          <div class="form-field">
            <input type="text" v-validate="'required'" name="name" :placeholder="$t('account.name')" v-model="profile.name" />
            <span>{{ errors.first('form-1.name') }}</span>
          </div>

          <div class="form-field">
            <datepicker v-model="profile.birthday" :placeholder="$t('account.birthday')"></datepicker>
          </div>

          <div class="form-field">
            <input type="text" :placeholder="$t('account.phone')" v-model="profile.phone" />
          </div>

          <div class="form-field">
            <input type="text" v-validate="'required|email'" name="email" :placeholder="$t('account.email')" v-model="profile.email" />
            <span>{{ errors.first('form-1.email') }}</span>
          </div>

          <div class="form-field has-buttons">
            <button type="submit" class="button" :class="{loading: update_profile}">{{$t('account.save_changes')}}</button>
          </div>
        </form>
      </div>

      <div class="col-6 col-xs-12" data-vv-scope="form-2">
        <h2 class="page-title">{{$t('account.change_password')}}</h2>
        <form @submit.prevent="changePassword('form-2')" class="columns column is-multiline is-12" data-vv-scope="form-2">
          <div class="form-field">
            <input type="password" v-model="password" :placeholder="$t('account.password')" v-validate="'required|confirmed:password'" ref="password" name="password" />
            <span>{{ errors.first('form-2.password') }}</span>
          </div>
          <div class="form-field">
            <input type="password" v-model="password_confirmation" :placeholder="$t('account.confirm_password')" v-validate="'required|confirmed:password'" name="password_confirmation" />
            <span>{{ errors.first('form-2.password_confirmation') }}</span>
          </div>
          <div class="form-field has-buttons">
            <button class="button" :class="{loading: update_password}">{{$t('account.change_password')}}</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker'
import Api from '@/services/api-service'
export default {
  name: 'profile',
  components: {
    Datepicker
  },
  data () {
    return {
      profile: this.$store.state.auth.user,
      update_profile: false,
      update_password: false,
      password: '',
      password_confirmation: ''
    }
  },
  methods: {
    editProfile (scope) {
      if(!this.update_profile) {
        this.$validator.validateAll(scope).then(result => {
          if (result) {
            this.update_profile = true
            Api.post('update-account', {
              profile: this.profile
            })
            .then(response => {
              this.update_profile = false
              this.$store.dispatch('fetchAuth', response.data.user)
            })
            .catch(error => {
              this.update_profile = false
            })
          } else {
            console.log(this.errors)
          }
        })
      }
    },
    changePassword (scope) {
      if(!this.update_password) {
        this.$validator.validateAll(scope).then(result => {
          if (result) {
            this.update_password = true
            Api.post('update-password', {
              id: this.profile.id,
              password: this.password,
              password_confirmation: this.password_confirmation
            })
            .then(response => {
              this.update_password = false
              this.password = ''
              this.password_confirmation = ''
              this.$validator.reset()
            })
            .catch(error => {
              this.update_password = false
            })
          } else {
            console.log(this.errors)
          }
        })
      }
    }
  }
}
</script>

<style lang="scss">
.profile {
}
</style>
